import {
  fasEnvelope,
  farFile,
  fasTv,
  fasChartLine,
  fasCommentSms,
  fasComment,
  fasPhone,
  fabFacebook,
  fabTwitter,
  fabFacebookMessenger,
  fabSquareTwitter,
  fabWhatsapp,
  fabInstagram,
  fabSquareInstagram,
} from '@quasar/extras/fontawesome-v6'
import { faMemo, faNotebook } from '@fortawesome/pro-regular-svg-icons'
import { getInlineIcon } from '@/common/helpers/icon'

export const enum CaseChannelEnum {
  MAIL = 'MAIL',
  FILE = 'FILE',
  FORM = 'FORM',
  SATISFACTION = 'SATISFACTION',
  SMS = 'SMS',
  CHAT = 'CHAT',
  CALL = 'CALL',
  FACEBOOK_POST = 'FACEBOOK_POST',
  TWITTER = 'TWITTER',
  FB_MESSENGER = 'FB_MESSENGER',
  TWITTER_DM = 'TWITTER_DM',
  API = 'API',
  WHATSAPP = 'WHATSAPP',
  INSTAGRAM = 'INSTAGRAM',
  INSTAGRAM_DM = 'INSTAGRAM_DM',
}

export const enum InteractionChannelEnum {
  MAIL = 'MAIL',
  SATISFACTION = 'SATISFACTION',
  SMS = 'SMS',
  CHAT = 'CHAT',
  CALL = 'CALL',
  FACEBOOK_POST = 'FACEBOOK_POST',
  TWITTER = 'TWITTER',
  FB_MESSENGER = 'FB_MESSENGER',
  TWITTER_DM = 'TWITTER_DM',
  API = 'API',
  WHATSAPP = 'WHATSAPP',
  INSTAGRAM = 'INSTAGRAM',
  INSTAGRAM_DM = 'INSTAGRAM_DM',
  EXTERNAL = 'EXTERNAL',
}

export const getCaseChannelIconName = (channelCode: CaseChannelEnum) => {
  switch (channelCode) {
    case CaseChannelEnum.MAIL:
      return fasEnvelope
    case CaseChannelEnum.FILE:
      return farFile
    case CaseChannelEnum.FORM:
      return fasTv
    case CaseChannelEnum.SATISFACTION:
      return fasChartLine
    case CaseChannelEnum.SMS:
      return fasCommentSms
    case CaseChannelEnum.CHAT:
      return fasComment
    case CaseChannelEnum.CALL:
      return fasPhone
    case CaseChannelEnum.FACEBOOK_POST:
      return fabFacebook
    case CaseChannelEnum.TWITTER:
      return fabTwitter
    case CaseChannelEnum.FB_MESSENGER:
      return fabFacebookMessenger
    case CaseChannelEnum.TWITTER_DM:
      return fabSquareTwitter
    case CaseChannelEnum.WHATSAPP:
      return fabWhatsapp
    case CaseChannelEnum.INSTAGRAM:
      return fabInstagram
    case CaseChannelEnum.INSTAGRAM_DM:
      return fabSquareInstagram
    case CaseChannelEnum.API:
      return getInlineIcon(faMemo)
    default:
      return undefined
  }
}

export const getInteractionChannelIconName = (channelCode: InteractionChannelEnum) => {
  switch (channelCode) {
    case InteractionChannelEnum.MAIL:
      return fasEnvelope
    case InteractionChannelEnum.SATISFACTION:
      return fasChartLine
    case InteractionChannelEnum.SMS:
      return fasCommentSms
    case InteractionChannelEnum.CHAT:
      return fasComment
    case InteractionChannelEnum.CALL:
      return fasPhone
    case InteractionChannelEnum.FACEBOOK_POST:
      return fabFacebook
    case InteractionChannelEnum.TWITTER:
      return fabTwitter
    case InteractionChannelEnum.FB_MESSENGER:
      return fabFacebookMessenger
    case InteractionChannelEnum.TWITTER_DM:
      return fabSquareTwitter
    case InteractionChannelEnum.WHATSAPP:
      return fabWhatsapp
    case InteractionChannelEnum.INSTAGRAM:
      return fabInstagram
    case InteractionChannelEnum.INSTAGRAM_DM:
      return fabSquareInstagram
    case InteractionChannelEnum.EXTERNAL:
      return getInlineIcon(faNotebook)
    case InteractionChannelEnum.API:
      return getInlineIcon(faMemo)
    default:
      return undefined
  }
}

export const Channels = {
  SMS: 8,
  CHAT: 9,
  FACEBOOK_POST: 12,
  TWITTER: 13,
  FB_MESSENGER: 14,
  TWITTER_DM: 15,
  WHATSAPP: 19,
  INSTAGRAM: 20,
  INSTAGRAM_DM: 21,
} as const

export type ChannelsIds = (typeof Channels)[keyof typeof Channels]

export type ChannelsAvailability = Partial<Record<ChannelsIds, boolean>>

export type ChannelDTOV1 = {
  code: CaseChannelEnum
  active: boolean
  displayOrder: number
}
